module.exports = __webpack_public_path__ + "img/bg_title2.ca3f26fa.png";